import React from "react";

interface CourseIconProps extends React.SVGProps<SVGSVGElement> {
  height?: string;
  width?: string;
  fill?: string;
  strokeColor?: string;
}

const CourseIcon: React.FC<CourseIconProps> = ({
  height = "100%",
  width = "100%",
  fill = "rgb(var(--pd-green))",
  strokeColor = "rgb(var(--pd-ink))",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.5 3 2.2 7.65a1.267 1.267 0 0 0-.085 2.219l6.659 3.995q.226.136.48.208l2.477.708a2 2 0 0 0 1.478-.151L22.236 9.9a.879.879 0 0 0 .045-1.532L17.5 5.5l-4.059-2.435a2 2 0 0 0-1.923-.074z"
      fill={fill}
      stroke={strokeColor}
    />
    <path
      d="M5 17.172V13a.862.862 0 0 1 1.296-.744l4.237 2.472a2 2 0 0 0 1.008.272h.987a2 2 0 0 0 .894-.211L16 13.5l2.706-1.547a.53.53 0 0 1 .794.46q0 .088.027.169l.324.97a2 2 0 0 1 .082.915l-.36 2.526a2 2 0 0 1-.38.917l-.593.79a2 2 0 0 1-1.6.8H7.328a2 2 0 0 1-1.414-.586l-.328-.328A2 2 0 0 1 5 17.172Z"
      fill={fill}
      stroke={strokeColor}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.842 11.438a.81.81 0 0 1 1.618 0v4.856a4.046 4.046 0 0 1-4.046 4.046H7.782a4.046 4.046 0 0 1-4.046-4.046v-4.856a.81.81 0 0 1 1.619 0v4.856a2.427 2.427 0 0 0 2.427 2.427h8.632a2.427 2.427 0 0 0 2.428-2.427z"
      fill="rgb(var(--pd-ink))"
      stroke="rgb(var(--pd-white))"
      strokeWidth={0.55}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.454 10.474C.844 10.136.5 9.544.5 8.927c0-.62.343-1.211.954-1.548l8.97-4.957a3.54 3.54 0 0 1 3.35 0l8.97 4.957c.61.337.954.928.954 1.548 0 .618-.343 1.21-.954 1.547l-8.97 4.957a3.53 3.53 0 0 1-3.35 0zm.782-1.417 8.97 4.957c.543.3 1.242.3 1.785 0l8.97-4.957c.06-.032.118-.071.118-.13s-.058-.099-.117-.132l-8.97-4.957c-.544-.3-1.243-.3-1.786 0l-8.97 4.957c-.06.033-.118.071-.118.132 0 .059.059.098.118.13Z"
      fill="rgb(var(--pd-ink))"
      stroke="rgb(var(--pd-white))"
      strokeWidth={0.55}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.526 9.852A.808.808 0 1 1 12.67 8.71l3.776 3.776a.8.8 0 0 1 .238.572v8.632a.81.81 0 0 1-1.619 0v-8.296z"
      fill="rgb(var(--pd-ink))"
      stroke="rgb(var(--pd-white))"
      strokeWidth={0.55}
    />
  </svg>
);

export default CourseIcon;
